import cianMetrics from '@cian/metrics';

export default function () {
    const setMetric = (name) => {
        cianMetrics.add(name);
    };

    return {
        setMetric,
        $get: ['$log', $log => {
            return {
                setMetric,
                sendMetric: (prefix, name, value, type='timer') => {
                    if (process.env.NODE_ENV !== 'development') {
                        cianMetrics.send([{
                            name: `${prefix}.${name}`,
                            type: type,
                            value: value
                        }]);
                    } else {
                        $log.debug('Send metric', prefix, name, value);
                    }
                },
                sendStats: (prefix) => {
                    if (process.env.NODE_ENV !== 'development') {
                        cianMetrics.waitForAllBrowserMetrics(() => {
                            const metrics = cianMetrics.collect(prefix);
                            if (process.env.SENTRY_RELEASE) {
                                metrics.push({
                                    name: 'versions.' + prefix + '.' + process.env.SENTRY_RELEASE.replace(/\./g, '_').toLowerCase(),
                                    type: 'counter',
                                    value: 1,
                                });
                            }
                            cianMetrics.send(metrics);
                        });
                    } else {
                        $log.debug('Send metrics', cianMetrics.collect(prefix));
                    }
                }
            }
        }]
    }
};
